import { Icon } from "components/Icon";
import styled from "styled-components/macro";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

interface NavigationMenuProps {
  ref: unknown;
  dataCy: string;
}

interface NavigationIconProps {
  showMenu: boolean;
}

type StyledIconProps = NavigationIconProps & Props;

export const StyledNavigationMenu = styled.div<NavigationMenuProps>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  width: 100%;
  cursor: pointer;
  margin-left: 24px;
`;

export const StyledNavigationLabel = styled.div<Props>`
  flex-direction: row-reverse;
  color: ${(props: Props) => props.theme.palette.neutral._80};
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
`;

export const StyledNavigationIcon = styled(Icon)<StyledIconProps>`
  font-size: 10px;
  color: ${(props: Props) => props.theme.palette.neutral._60};
  padding-left: 6px;
`;
